<template>
  <section id="main-wrap" class="pure-g">  
    <div id="main-col" class="pure-u-3-5">
      <div v-html="content" style="max-width: 750px;"></div>
    </div>
  </section>
</template>

<script>
  /* global $ */
  import db from '../firebaseInit'
  import Grape from '../Grape.vue'
  export default {
    name: 'view-grape',
    data () {
      return {
        grapes: [],
        title: null,
        image: null,
        id: null,
        content: '',
        description: null,
        createdTimestamp: null,
        updatedTimestamp: null
      }
    },
    metaInfo () {
      return {
        title: this.title,
        meta: [
          { name: 'description', content: this.description },
          { itemprop: 'name', content: this.title },
          { itemprop: 'description', content: this.description },
          { itemprop: 'image', content: this.image },
          { name: 'twitter:card', content: 'summary' },
          { name: 'twitter:site', content: '@grapevine' },
          { name: 'twitter:title', content: this.title },
          { name: 'twitter:description', content: this.description },
          { name: 'twitter:image:src', content: this.image },
          { vmid: 'og:title', property: 'og:title', content: this.title },
          { vmid: 'og:type', property: 'og:title', content: 'article' },
          { vmid: 'og:url', property: 'og:url', content: 'https://atgrapevine.com/%23/view-grape/' + this.id },
          { vmid: 'og:image', property: 'og:image', content: this.image },
          { vmid: 'og:description', property: 'og:description', content: this.description },
          { vmid: 'og:site_name', property: 'og:site_name', content: 'Grapevine' },
          { vmid: 'article:published_time', property: 'article:published_time', content: this.createdTimestamp },
          { vmid: 'article:modified_time', property: 'article:modified_time', content: this.updatedTimestamp }
        ]
      }
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
        this.grapes = []
        db.collection('grapes').where('id', '==', this.$route.params.grapeID).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log(doc.id, ' => ', doc.data())
            var grapeData = doc.data()
            grapeData.docID = doc.id
            this.grapes.push(grapeData)
            this.title = grapeData.grapeTitle
            this.image = grapeData.sourceImage
            this.id = grapeData.id
            this.description = grapeData.grapeContent
            this.createdTimestamp = grapeData.createdTimestamp
            this.updatedTimestamp = grapeData.updatedTimestamp

            this.description = $(this.description).text()
            this.description = this.description.length > 155 ? this.description.substring(0, 150) + '...' : this.description

            // header
            this.content += '<link href="https://fonts.googleapis.com/css?family=PT+Sans" rel="stylesheet">'
            this.content += '<div style="text-align: center;background: #485057;padding: 0 20px;color: #202020; font-family: \'PT Sans\', \'Open Sans\', Helvetica, sans-serif;">'
            this.content += '<a href="https://atgrapevine.com" target="_blank" style="vertical-align: middle;line-height: 18px;display: inline-block;float: left; line-height: 90px;"><img src="https://gallery.mailchimp.com/f4ce55a7d5e2bd08e71359674/images/5b37315b-119d-4773-8e58-0b37d83754cb.png" style="width: 70px;margin: 18px 0;" /></a>'
            this.content += '<h1 style="color: #fff;line-height: 90px;display: inline-block;margin: 0;padding: 0;font-size: 2.4em; font-weight: 400;">grapevine</h1>'
            this.content += '<div style="float: right;display: inline-block;line-height: 90px;">'
            this.content += '<a href="http://twitter.com/notesonthecraft" style="vertical-align: middle;line-height: 18px;display: inline-block;margin: 0 5px;"><img src="https://gallery.mailchimp.com/f4ce55a7d5e2bd08e71359674/images/8b142a22-96cd-4f7b-bc90-dd16740988f2.png" style="width: 28px;height: auto;border: 0;outline: none;text-decoration: none;"></a>'
            this.content += '<a href="#" style="vertical-align: middle;line-height: 18px;display: inline-block;margin: 0 5px;"><img src="https://gallery.mailchimp.com/f4ce55a7d5e2bd08e71359674/images/9d4c7c15-c779-4921-b3e3-c22f9bc0cf2b.png" style="width: 28px;height: auto;border: 0;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;"></a>'
            this.content += '<a href="#" style="vertical-align: middle;line-height: 18px;display: inline-block;margin: 0 5px;"><img src="https://gallery.mailchimp.com/f4ce55a7d5e2bd08e71359674/images/759ad953-ca9e-41cb-b5f1-6cd1034d7669.png" style="width: 28px;height: auto;border: 0;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;"></a>'
            this.content += '</div>'
            this.content += '</div>'

            // intro
            this.content += '<div style="text-align: left; padding: 68px 50px 48px; font-size: 1.2em;"><span style="font-weight: bold;">Hi&nbsp; *|FNAME|*, here is your grape of the day.</span><span style="display:block; float:right; white-space:pre-wrap">*|MC:DATE|*</span></span></div>'

            // grape
            this.content += '<div style="text-align: left; padding: 0 50px; margin-bottom: 50px;">'
            this.content += '<div style="text-align: left; width: 100%; border-bottom: 1px solid #eaeaea;padding-bottom: 2px;font-size: 1em;margin-bottom: 10px;"><span style="color: #43B73B;">@' + grapeData.grapeUsername + '</span><span style="float: right;">' + grapeData.grapeLength + ' words</span></div>'            
            this.content += '<img src="' + grapeData.sourceImage + '" style="float: left; margin: 40px 40px 50px 0;"/>'
            this.content += '<h4 class="grape-author" style="font-size: 1.8em;text-transform: uppercase;font-weight: 700;color: #43B73B;margin: 20px 0 10px;padding-top: 45px;">' + grapeData.sourceAuthor + '</h4>'
            this.content += '<h3 style="margin-top: .8em;font-size: 1.35em;padding-bottom: 7.5px;">' + grapeData.grapeTitle + '</h3>'
            this.content += '<hr style="width: 30%;margin: 0;border: 0; border-top: 1px solid #eaeaea;" />'
            this.content += '<h5 style="font-size: 1.1em; font-weight: normal; font-style: italic;">' + grapeData.grapeSource + ' <span style="font-style: normal;">(' + grapeData.grapeOriginalPublishYear + ')</span></h5>'
            grapeData.grapeContent = grapeData.grapeContent.replace(/\<p/g, '<p style="margin: 0;"')
            this.content += '<div style="clear: both; line-height: 1.6em;font-size: 1.2em;">' + grapeData.grapeContent + '</div>'
            this.content += '</div>'

            // footer
            this.content += '<div><a href="https://atgrapevine.com" target="_blank" style="display: block;width: 100%;text-decoration: none;background: #36a731;padding: 20px;box-sizing: border-box;color: #fff;">Go to atgrapevine.com</a></div>'

            $('body').removeClass('pace-running')
            $('.pace').removeClass('pace-active')
          })
        })
      }
    },
    components: {
      Grape
    }
  }
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  h1 {
    font-size: 30px;
    margin: 30px 0;
  }
  p {
    margin-bottom: 20px;
  }
  .contact--section {
    background-color: white;
    padding: 20px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
    .__name {
      font-size: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/grapeEmailDraft.vue